import type { Observable as ObservableType } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import { SPRINT } from '../../model/constants';
import type { CardList } from '../../model/types';
import createSprintRest, { type Sprint } from '../../rest/sprint-create';

const transformer = (response: Sprint): CardList => ({
	id: String(response.id),
	name: response.name,
	type: SPRINT,
	issueListKey: null,
	sprintData: {
		goal: '',
		startDate: response.isoStartDate,
		endDate: response.isoEndDate,
		daysRemaining: response.daysRemaining,
		state: response.state,
		canUpdateSprint: response.canUpdateSprint,
	},
});

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default (baseUrl: string, rapidViewId: string): ObservableType<CardList> =>
	createSprintRest(baseUrl, rapidViewId).map(transformer);
